import { ApolloClient, InMemoryCache } from '@apollo/client';

import { IS_TEST_RUNNER } from '@sorare/core/src/config';

import { GRAPHQL_ENDPOINT } from 'constants/config';

export const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          posts: {
            keyArgs: ['where'],
            merge(existing = { nodes: [] }, incoming = { nodes: [] }) {
              return {
                ...incoming,
                nodes: [...existing.nodes, ...(incoming.nodes || [])],
              };
            },
          },
        },
      },
    },
  }),
  devtools: {
    enabled: !IS_TEST_RUNNER,
  },
});
